const SHORT_ID_LENGTH = 8;

export const shortId = (id: string): string => id.slice(0, SHORT_ID_LENGTH);
